<form [formGroup]="dropDownForm" novalidate>
  <mat-form-field appearance="outline" class="w-full my-2">
    <mat-select
      [compareWith]="compareFn"
      formControlName="dropDown"
      #gridViewSelect
      panelClass="wcg-mat-select-panel"
    >
      <div class="grid-view-drop-down__panel">
        @for (
          option of viewsOptions();
          track viewOption($index, option);
          let last = $last
        ) {
          @let label = option.label;
          <mat-option [value]="option">
            <span [wcgDropDownOptionOverflowTooltip]="label">
              {{ label }}
            </span>
          </mat-option>
        }
      </div>
      <footer>
        <span
          mat-menu-item
          (click)="openDialog('Edit')"
          [ngClass]="{
            'grid-view-drop-down__edit-btn-disable': $totalGridViews() <= 0,
          }"
          ><mat-icon>edit</mat-icon>
          Edit table views
        </span>
      </footer>
    </mat-select>
  </mat-form-field>
</form>
